var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "authenticationdocs" },
    [
      _c("v-app", [
        _c(
          "article",
          [
            _c("p", { staticClass: "docs-logo" }, [
              _c("img", {
                attrs: {
                  src: require("../../../common/assets/images/Logo_4iQ-DEEP_with_R_MAIN_gray.svg")
                }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "docs-headline" }, [
              _vm._v("2FA Documentation")
            ]),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "auth-main-conatiner" },
              [
                _c("p", [
                  _c("strong", [_c("span", [_vm._v("How to setup 2FA .?")])])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "This guide will show you the steps you need to follow in order to add UIGateway Security on authentication apps."
                  )
                ]),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [
                    _c("span", [
                      _vm._v(
                        "Setting up the Google Authenticator on the Phone:"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("ol", [
                  _c("li", [
                    _vm._v(
                      "Download the Google Authenticator application from "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [_vm._v("Google Play")]
                    ),
                    _vm._v(" or "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://itunes.apple.com/ro/app/google-authenticator/id388497605",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [_vm._v("AppStore")]
                    ),
                    _vm._v(" (or download the Microsoft Authenticator from "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://www.microsoft.com/en-gb/p/authenticator/9wzdncrfj3rj",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [_vm._v("Microsoft Store")]
                    ),
                    _vm._v(") ")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("Open the application and touch the "),
                    _c("em", [_vm._v("Begin")]),
                    _vm._v(" button to start the configuration")
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../../common/assets/images/googleauthenticator.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("3. Select the "),
                  _c("em", [_vm._v("Scan a barcode")]),
                  _vm._v(
                    " option, which will prompt access to use the camera of your phone, and scan the QR Code from the "
                  ),
                  _c(
                    "a",
                    { attrs: { href: "#", target: "_blank", rel: "noopener" } },
                    [_vm._v("UIGateway login")]
                  ),
                  _vm._v(" page")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../../common/assets/images/googlescanbarcode.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Please scan the barcode using your mobile authentication app"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Reference image : You will observe same page by providing credentials to login page"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../../common/assets/images/uigateway2fa_new.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "4. The account is now synced with the authenticator from the browser and is ready to be used"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("5. Use the generated code to login into the "),
                  _c(
                    "a",
                    { attrs: { href: "#", target: "_blank", rel: "noopener" } },
                    [_vm._v("UIGateway")]
                  )
                ]),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [
                    _c("span", [
                      _vm._v(
                        "Setting up google Authenticator on Google Chrome:"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("p", [_c("strong", [_vm._v("Step 1")])]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Click on: "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai?hl=en",
                        target: "_blank"
                      }
                    },
                    [_vm._v("Download")]
                  ),
                  _vm._v(
                    " and add the google Authenticator extension to the browser if asked to do so or click on the "
                  ),
                  _c("em", [_vm._v("Add to Chrome button > Add extension")])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    staticClass: "google-auth",
                    attrs: {
                      src: require("../../../common/assets/images/googleauth.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", [_c("strong", [_vm._v("Step 2")])]),
                _vm._v(" "),
                _c("ol", [
                  _c("li", [
                    _vm._v("Now the extension is added to the browser")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "Click on the extention and click scan QR code beside Pencil icon"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../../common/assets/images/scanqrcode.png"),
                      alt: "",
                      width: "590",
                      height: "560"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("scan the QR code from"),
                  _c(
                    "a",
                    { attrs: { href: "#", target: "_blank", rel: "noopener" } },
                    [_vm._v("Login page")]
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Qr code is visible once credentials are given and click on sign in."
                  )
                ]),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_c("span", [_vm._v("2FA Backup Codes:")])])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "These are the codes used for login if user unable to access Google Authenticator app."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Here you can use backup codes instead of Google Authenticator Six digits code to get logged in."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    attrs: {
                      src: require("../../../common/assets/images/2FABackupCodeInput_new.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [
                    _c("span", [_vm._v("How to retrieve 2FA Backup Codes:")])
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "A popup with backup codes will appear after user logged in for the first time"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("img", {
                    staticClass: "backup-codes-popup",
                    attrs: {
                      src: require("../../../common/assets/images/backupCodesPopup.png")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c("p", { staticClass: "docs-headline" }, [
                  _vm._v("All Done , 2FA setup is successful.")
                ]),
                _vm._v(" "),
                _c("v-divider")
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }